export const environment = {
  production: true,
  apiUrl: 'https://onlinekviz.cz/api',
  url: 'https://onlinekviz.cz/'
  // apiUrl: 'http://test.onlinekviz.cz/api',
  // url: 'http://test.onlinekviz.cz/'
};
